import * as actions from '../services'
import * as types from './mutations-types'
import { t } from 'src/utils/form'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'

export const loadPaymentMethods = (context, payload) => {
  return actions.getPaymentMethods(payload)
    .then(response => {
      if (response && response.status === 200) {
        context.commit(types.setPaymentMethods, response.data.payment_methods)
      } else {
        context.commit(addFlash, { message: t(context, 'settings.alerts.gateway_communication_error'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
      }
    })
}

export const editPaymentMethodConfigs = (context, payload) => {
  return actions.updatePaymentMethodConfigs(payload)
  .then(function (response) {
    if (response.status === 200 || response.status === 304) {
      context.commit(addFlash, { message: t(context, 'application.alert.changes_have_been_saved'), type: 'ls-alert-success' })
      context.commit(types.setPaymentMethodConfigs, response.data.payment_method)
    } else {
      context.commit(addFlash, { message: t(context, 'settings.alerts.action_warning'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
    }
    return response
  })
}

export const loadProcessors = (context) => {
  return actions.getProcessors()
    .then(response => {
      if (response && response.status === 200) {
        context.commit(types.setProcessors, response.data)
      } else {
        context.commit(addFlash, { message: t(context, 'settings.alerts.gateway_communication_error'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
      }
    })
}

export const loadNewPaymentMethods = (context, payload) => {
  return actions.getNewPaymentMethods(payload)
    .then(response => {
      if (response && response.status === 200) {
        context.commit(types.setPaymentMethods, response.data.payment_methods)
      } else {
        context.commit(addFlash, { message: t(context, 'settings.alerts.gateway_communication_error'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
      }
    })
}

export const loadCustomFields = (context, payload) => {
  return actions.getCustomFields(payload)
    .then(response => {
      if (response && response.status === 200) {
        context.commit(types.setCustomFields, response.data.custom_fields)
      } else {
        context.commit(addFlash, { message: t(context, 'settings.alerts.gateway_communication_error'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
      }
    })
}

export const loadCustomFieldsValues = (context, payload) => {
  return actions.getCustomFieldsValues(payload)
    .then(response => {
      if (response && response.status === 200) {
        context.commit(types.setCustomFieldsValues, response.data)
      } else {
        context.commit(addFlash, { message: t(context, 'settings.alerts.gateway_communication_error'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
      }
    })
}

export const updatePaymentMethods = (context, payload) => {
  return actions.updatePaymentMethods(payload)
    .then(response => {
      if (response && response.status === 200) {
        context.commit(addFlash, { message: t(context, 'settings.alerts.action_success'), name: 'response.data.paymentMethod', type: 'ls-alert-success' })
      } else {
        context.commit(addFlash, { message: t(context, 'settings.alerts.action_warning'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
      }
    })
}

export const checkCep = (context, payload) => {
  return actions.findCep(payload)
  .then(function (response) {
    var ctx = context
    if (context.$store) ctx = context.$store
    if (response && response.status === 200) {
      ctx.commit(types.setAddressFound, response.data)
    } else {
      ctx.commit(types.setAddressFound, {})
    }
    return response
  })
}

export const loadBilletMethod = (context) => {
  return actions.getBilletMethod()
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.billetMethod, response.data.setting.value)
      }
      return response
    })
}

export const loadReprocessBilletMethod = (context) => {
  return actions.getReprocessBilletMethod()
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.reprocessBilletMethod, response.data.setting.value)
      }
      return response
    })
}

export const loadCardMethod = (context) => {
  return actions.getCardMethod()
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.cardMethod, response.data.setting.value)
      }
      return response
    })
}

export const loadReprocessCardMethod = (context) => {
  return actions.getReprocessCardMethod()
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.reprocessCardMethod, response.data.setting.value)
      }
      return response
    })
}

export const loadTransferMethod = (context) => {
  return actions.getTransferMethod()
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.transferMethod, response.data.setting.value)
      }
      return response
    })
}

export const loadBalanceMethod = (context, payload) => {
  return actions.getSetting(payload.id)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.balanceMethod, response.data.setting.value)
    }
    return response
  })
}

export const loadBillingSetting = (context, billingSettingId) => {
  return actions.getSetting(billingSettingId)
    .then(function (response) {
      if (response && response.status === 200) {
        if (billingSettingId === '23') {
          response.data.setting.value = !!+response.data.setting.value
          return context.commit(types.setBillingSettings, response.data.setting)
        }
        context.commit(types.setBillingSettings, response.data.setting)
      }
      return response
    })
}

export const loadWebhookSetting = (context, webhookSettingId) => {
  return actions.getSetting(webhookSettingId)
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.setWebhookSettings, response.data.setting)
      }
      return response
    })
}

export const loadNfeSetting = (context, nfeSettingId) => {
  return actions.getSetting(nfeSettingId)
    .then(function (response) {
      if (response && (response.status === 200 || response.status === 304)) {
        context.commit(types.setNfeSettings, response.data.setting)
        return response.data.setting.value
      }
      return response
    })
}

export const loadYapayToken = (context, payload) => {
  return actions.getSetting(payload.id)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.yapayToken, response.data.setting.value)
      return response.data.setting.value
    }
    return response
  })
}

export const updateBillingSetting = (context, payload) => {
  return actions.updateSetting(payload)
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(addFlash, { message: t(context, 'application.alert.changes_have_been_saved'), type: 'ls-alert-success' })
        if (response.data.setting.id === 23) {
          response.data.setting.value = !!+response.data.setting.value
          return context.commit(types.setBillingSettings, response.data.setting)
        }
        context.commit(types.setBillingSettings, response.data.setting)
      }
      return response
    })
}

export const updateYapayToken = (context, payload) => {
  return actions.updateSetting(payload)
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.yapayToken, response.data.setting.value)
      }
      return response
    })
}

export const updateWebhookSetting = (context, payload) => {
  return actions.updateSetting(payload)
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(addFlash, { message: t(context, 'application.alert.changes_have_been_saved'), type: 'ls-alert-success' })
        context.commit(types.setWebhookSettings, response.data.setting)
      }
      return response
    })
}

export const updateNfeSetting = (context, payload) => {
  return actions.updateSetting(payload)
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(addFlash, { message: t(context, 'application.alert.changes_have_been_saved'), type: 'ls-alert-success' })
        context.commit(types.setNfeSettings, response.data.setting)
      }
      return response
    })
}

export const loadGatewayFieldsValues = (context) => {
  return actions.getGatewayFieldsValues()
    .then(response => {
      if (response && (response.status === 200 || response.status === 304)) {
        context.commit(types.setGatewayFieldsValues, response.data)
      } else {
        context.commit(addFlash, { message: t(context, 'settings.alerts.nf_communication_error'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
      }
    })
}

export const setupSeller = (context, payload) => {
  return actions.setupSeller(payload)
    .then(function (response) {
      if (response.status === 200) {
        context.commit(addFlash, { message: t(context, 'settings.alerts.nf_seller_success'), type: 'ls-alert-success' })
        context.commit(types.setGatewayFieldsValues, response.data)
      } else {
        context.commit(addFlash, { message: t(context, 'settings.alerts.nf_seller_failure'), name: 'response.data.paymentMethod', type: 'ls-alert-danger' })
      }
      return response
    })
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/vuex/actions.js